import BaseService from './BaseService';
import { camelizeKeys } from 'humps';

const objectType = 'route-section-zones';

class RouteSectionZonesService extends BaseService {

  static getList() {

    return super.get('lookup/route_section_zones?paginate=false')
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });

  }

  static create(data) {
    return super.post(objectType, `lookup/route_section_zones`, data)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static update(data) {

    return super.patch(objectType, `lookup/route_section_zones/${data.id}`, data)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static delete(id) {
    return super.delete(`lookup/route_section_zones/${id}`)
      .then((response) => {
        return Promise.resolve({id});
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });
  }

}

export default RouteSectionZonesService;